<template>
  <div v-if="value" class="inv-overlay" @click.self="$emit('input', false)">
    <div class="inv-modal inv-modal--sm">
      <div class="inv-modal__header inv-modal__header--danger">
        <span>⚠ DELETE CONFIRMATION</span>
        <button class="inv-modal__close" @click="$emit('input', false)">×</button>
      </div>
      <div class="inv-modal__body">
        <p>Are you sure you want to delete this item?</p>
        <p class="inv-modal__highlight">{{ item && item.name }}</p>
        <p class="inv-modal__sub">This action cannot be undone.</p>
      </div>
      <div class="inv-modal__footer">
        <button class="inv-btn inv-btn--ghost" @click="$emit('input', false)">Cancel</button>
        <button class="inv-btn inv-btn--danger" @click="$emit('confirm')">Delete</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolsDeleteDialog',
  props: {
    value: { type: Boolean, default: false },
    item:  { type: Object,  default: null },
  },
}
</script>

<style scoped>
.inv-overlay {
  position: fixed; inset: 0; z-index: 999;
  background: rgba(0,0,0,0.35);
  display: flex; align-items: center; justify-content: center;
  backdrop-filter: blur(2px);
}
.inv-modal {
  background: var(--bg2); border: 1px solid var(--border2);
  box-shadow: 0 24px 64px rgba(0,0,0,0.15);
  display: flex; flex-direction: column; max-height: 90vh; overflow: hidden;
}
.inv-modal--sm { width: 420px; }
.inv-modal__header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 16px 20px; border-bottom: 1px solid var(--border);
  font-family: 'IBM Plex Mono', monospace; font-size: 16px; font-weight: 700;
  letter-spacing: 0.08em; color: var(--text-bright); background: var(--bg3);
}
.inv-modal__header--danger { border-bottom-color: var(--danger); }
.inv-modal__close { background: none; border: none; color: var(--text-dim); font-size: 23px; cursor: pointer; line-height: 1; padding: 0 4px; }
.inv-modal__close:hover { color: var(--text); }
.inv-modal__body  { padding: 24px 20px; overflow-y: auto; flex: 1; font-size: 16px; }
.inv-modal__highlight { font-weight: 700; color: var(--text-bright); font-size: 18px; margin: 6px 0; }
.inv-modal__sub   { font-size: 15px; color: var(--text-dim); font-family: 'IBM Plex Mono', monospace; }
.inv-modal__footer { padding: 14px 20px; border-top: 1px solid var(--border); display: flex; justify-content: flex-end; gap: 10px; background: var(--bg3); }
.inv-btn { font-family: 'IBM Plex Mono', monospace; font-size: 14px; font-weight: 600; letter-spacing: 0.1em; padding: 8px 18px; border: 1px solid; cursor: pointer; transition: all 0.15s; display: inline-flex; align-items: center; gap: 6px; }
.inv-btn--ghost  { background: transparent; border-color: var(--border2); color: var(--text); }
.inv-btn--ghost:hover { border-color: var(--text-dim); }
.inv-btn--danger { background: var(--danger); border-color: var(--danger); color: #fff; }
.inv-btn--danger:hover { filter: brightness(1.1); }
</style>